import { useFeatureIdentify } from 'map-feature-info'
import { clearSelectedFeature } from '~map-feature-info/states/map'
import { useDispatch } from '~map-feature-info/states'
import { useEffect } from 'react'
import { PointSelectorPlugin } from '~map-preview/App/Map/Plugins/PointSelectorPlugin'
import { useMapNavStore } from '~map-preview/states/mapNav'

interface FeatureIdentifyPluginProps {
  layer: string
}

function FeatureIdentifyPlugin(props: FeatureIdentifyPluginProps) {
  const { layer } = props
  const { setSideBar, setOpenDrawer, setOpenMapFeatureInfo, drawerOpen } =
    useMapNavStore()
  const dispatch = useDispatch()

  const { identify } = useFeatureIdentify()

  useEffect(() => {
    if (!drawerOpen) {
      dispatch(clearSelectedFeature())
    }
  }, [drawerOpen, dispatch])

  const handlePointSelect = (feature) => {
    identify(feature)
    setSideBar('mapFeatureInfo')
    setOpenDrawer(true)
    setOpenMapFeatureInfo(true)
  }

  const handlePointDeselect = () => {
    setOpenDrawer(false)
  }

  return (
    <PointSelectorPlugin
      layer={layer}
      onPointSelect={handlePointSelect}
      onPointDeselect={handlePointDeselect}
    />
  )
}

export { FeatureIdentifyPlugin }
